import { useAccessibleProducts, type AccessibleProduct } from '../../hooks/useAccessibleProducts';

interface Props {
  value: number | null;
  onChange: (productId: number) => void;
  label?: string;
}

export function ProductSelector({ value, onChange, label = 'Produto' }: Props) {
  const { data: products = [], isLoading } = useAccessibleProducts();

  if (isLoading) {
    return null;
  }
  if (products.length === 0) {
    return null;
  }
  if (products.length === 1) {
    const only = products[0];
    return <span className="text-sm text-ink-secondary font-medium">{only.name}</span>;
  }

  return (
    <label className="flex items-center gap-2 text-sm text-ink-secondary">
      {label}:
      <select
        className="input w-auto"
        value={value ?? products[0]?.id ?? ''}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {products.map((p: AccessibleProduct) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>
    </label>
  );
}
